import { Button, Input } from "antd";
import { PAGE_LENGTH } from "../config";
import { useAlert } from "../context/AlertProvider";

const QuickSelection = ({
  selectedRange,
  onChangeSelectedRange,
  onClickQuickSelection,
  onClearQuickSelection,
  isClearVisible,
  totalRecords,
}) => {
  const { showAlert } = useAlert();

  const handleSelectData = () => {
    const totalPages = Math.ceil(totalRecords / PAGE_LENGTH);
    const start = parseInt(selectedRange.start);
    const end = parseInt(selectedRange?.end);
    if (start && end) {
      const calcRecords =
        (parseInt(selectedRange.end) - parseInt(selectedRange.start)) * 10;

      let errorMessage = "";

      const validationCase =
        start > end
          ? "START_GREATER_THAN_END"
          : end > totalPages
            ? "END_EXCEEDS_TOTAL"
            : calcRecords > 500
              ? "MAX_PAGES_EXCEEDED"
              : null;

      switch (validationCase) {
        case "START_GREATER_THAN_END":
          errorMessage = "Start page number must be less than end page number.";
          break;
        case "END_EXCEEDS_TOTAL":
          errorMessage = "End page number must be less than total page.";
          break;
        case "MAX_PAGES_EXCEEDED":
          errorMessage = "Please select a maximum of 50 pages at a time.";
          break;
        default:
          errorMessage = null;
      }

      if (errorMessage) {
        showAlert("error", errorMessage);
      } else {
        onClickQuickSelection();
      }
    } else {
      if (start === 0) {
        showAlert("error", "Start page number must be greater than zero.");
      } else {
        showAlert(
          "error",
          "Please select start page number and end page number.",
        );
      }
    }
  };

  return (
    <nav className="navbar navbar-light bg-white topbar mr-2 mb-4 static-top">
      <div className="buttons-container-top m-mt quickselection">
        <div>
          <span className="fs-13 mr-2">Quick Selection</span>
          <div className=" fs-13 d-sm-inline-block mr-1">
            <Input
              name="start"
              type="number"
              value={selectedRange?.start}
              className="quickselectioninput btn-outline-grey"
              maxLength={4}
              min={1}
              onChange={onChangeSelectedRange}
            />
          </div>
          <span className="fs-13 mr-1">to</span>
          <div className="fs-13 d-sm-inline-block mr-1">
            <Input
              name="end"
              type="number"
              value={selectedRange?.end}
              maxLength={4}
              min={1}
              className="quickselectioninput btn-outline-grey"
              onChange={onChangeSelectedRange}
            />
          </div>
          <Button
            type="primary"
            className="fs-12 d-sm-inline-block mr-1 quick-btn"
            onClick={handleSelectData}
          >
            <i className="fas fs-12 fa-arrow-right"></i>
          </Button>
          {isClearVisible ? (
            <Button
              type="primary"
              className="fs-12  mr-1"
              onClick={onClearQuickSelection}
            >
              Clear Selection
            </Button>
          ) : (
            ""
          )}
        </div>
      </div>
    </nav>
  );
};

export default QuickSelection;
